module.exports = __webpack_public_path__ + "img/icon6.05ea5d64.png";